import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HeaderItem } from '@entities/domains/header.entity';

export abstract class HeaderRepository {
  abstract getMenuheader(isEnglish: boolean): Observable<HeaderItem>;
  abstract getLogoPaths(router: Router): Observable<{ logoUrl: string }>;
}
